import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./index";
import UnitType from "../features/rapidstor/entities/UnitType";
import Location from "../features/rapidstor/entities/Location";
import Descriptor from "../features/rapidstor/entities/Descriptor";
// import { ReservationPayload } from "../services/rapidstor";
import { RapidStorReservationRequest } from "../services/rapidstor";
import Charge from "@r6digital/rapidstor-types/types/Charge";
import { RapidStorMerchandise } from "@r6digital/rapidstor-types/types/Api";

export interface UnitData {
  location: Location;
  unitType: UnitType;
  unitSizes: (number | string)[];
  descriptors: Array<Descriptor>;
  selectedDescriptor: Descriptor;
  reservation?: boolean;
}

export interface ContactData {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  addr1: string | null;
  addr2: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  declaredInsuranceAmt: number | null;
}

export interface Extras {
  charges: Charge[];
  merchandise: RapidStorMerchandise;
}

interface State {
  unitData: UnitData | null;
  contactData: ContactData | null;
  reservationData: RapidStorReservationRequest | null;
  reservationToken: string | null;
  extras: Extras | null;
}

const initialState: State = {
  unitData: null,
  contactData: null,
  reservationData: null,
  reservationToken: null,
  extras: null,
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setUnitData: (state, action: { payload: UnitData; type: string }) => {
      state.unitData = action.payload;
    },
    setReservationData: (
      state,
      action: { payload: RapidStorReservationRequest; type: string }
    ) => {
      state.reservationData = action.payload;
    },
    setContactData: (state, action: { payload: ContactData; type: string }) => {
      state.contactData = action.payload;
    },
    setReservationToken: (state, action: { payload: string; type: string }) => {
      state.reservationToken = action.payload;
    },
    setExtras: (state, action: { payload: Extras; type: string }) => {
      state.extras = action.payload;
    },
  },
});

export const {
  setUnitData,
  setContactData,
  setReservationData,
  setReservationToken,
  setExtras,
} = bookingSlice.actions;

export const selectUnitData = (state: RootState) => state.booking.unitData;
export const selectReservationData = (state: RootState) => state.booking.reservationData;
export const selectContactData = (state: RootState) => state.booking.contactData;
export const selectReservationToken = (state: RootState) =>
  state.booking.reservationToken;
export const selectExtras = (state: RootState) => state.booking.extras;
